module.exports = __webpack_public_path__ + "static/media/6H.8875fac4.svg";